var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailLine = function SvgMailLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.25 3.75h13.5a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-.75.75H3.25a.75.75 0 0 1-.75-.75v-11a.75.75 0 0 1 .75-.75M16 6.928l-5.946 5.326L4 6.912v7.838h12zM4.383 5.25l5.663 4.996 5.58-4.996z"
  })));
};
export default SvgMailLine;